import React from 'react';
import PropTypes from 'prop-types';
import {
    Drawer,
    Paragraph,
    Button,
    ButtonToolbar,
    Form,
    FormControl,
    FormGroup,
    ControlLabel,
    HelpBlock,
    DatePicker,
    InputPicker

} from 'rsuite';
import RFormControl from '../../../componentsGeneral/Rsuite/Form/RFormControl';
import { lettersNumbersDashesInputMask, numbersInputMask, lettersNumbersDashesSpacesInputMask, textStringInputMask } from '../../../../resources/logic/inputMasks';

const styles = {
    // width: 300,
    marginBottom: 10,
    width: '100%'
};

const dropDownLclFcl = [
    {
        "label": "LCL",
        "value": "LCL"
    },
    {
        "label": "FCL",
        "value": "FCL"
    }
]

const mountRef = React.createRef();

const AddNewContainerDrawer = ({ onChangeAddNewContainer, show, placement, confirm, close, state, ...props }) => (

    <Drawer show={state.showAddNewContainerDrawer} onHide={close} placement={placement} style={props.isMobile ? { width: '350px' } : { width: '650px' }}    >
        <Drawer.Header>
            <Drawer.Title>Add New Container</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body> <div ref={mountRef}>

            <Form fluid>

                <FormGroup>
                    <ControlLabel>Container</ControlLabel>
                    <FormControl readOnly name="Container" value={state.Container} />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Warehouse</ControlLabel>
                    <InputPicker preventOverflow
                        container={() => mountRef.current}

                        placeholder={'Select...'}
                        value={state.WarehouseID}
                        onChange={(e) => { onChangeAddNewContainer(e, 'WarehouseID') }}
                        data={state.warehouseArray}
                        block
                        cleanable={true}
                    />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Customer</ControlLabel>
                    <InputPicker preventOverflow
                        container={() => mountRef.current}

                        placeholder={'Select...'}
                        value={state.CustomerID}
                        onChange={(e) => { onChangeAddNewContainer(e, 'CustomerID') }}
                        data={state.customerArray}
                        block
                        cleanable={true}
                    />
                </FormGroup>


                <FormGroup>
                    <ControlLabel>LCL FCL</ControlLabel>
                    {/* <FormControl name="CarrierName" value={state.CarrierName} onChange={(e) => {onChangeAddNewContainer(e,'CarrierName')}}  onInput={(e) =>  e.target.value = lettersNumbersDashesSpacesInputMask(e)} /> */}
                    <InputPicker preventOverflow
                        container={() => mountRef.current}

                        placeholder={'Select...'}
                        value={state.LclFcl}
                        onChange={(e) => { onChangeAddNewContainer(e, 'LclFcl') }}
                        data={dropDownLclFcl}
                        block
                        cleanable={true}
                    />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Delivery Appointment</ControlLabel>
                    <DatePicker
                        container={() => mountRef.current}
                        placeholder="Delivery Appointment"
                        onChange={(e) => { onChangeAddNewContainer(e, 'DeliveryAppointment') }}
                        value={state.DeliveryAppointment}
                        format="YYYY-MM-DD hh:mm aa"
                        defaultValue={new Date(new Date().setHours(0, 0, 0, 0))}
                        showMeridian
                        ranges={[
                            {
                                label: 'Now',
                                value: new Date()
                            }
                        ]}
                        style={styles}
                    />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>ETD</ControlLabel>
                    <DatePicker
                        container={() => mountRef.current} oneTap style={styles} placeholder="ETD" value={state.ETD} onChange={(e) => { onChangeAddNewContainer(e, 'ETD') }} />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>ETA</ControlLabel>
                    <DatePicker
                        container={() => mountRef.current} oneTap style={styles} placeholder="ETA" value={state.ETA} onChange={(e) => { onChangeAddNewContainer(e, 'ETA') }} />
                </FormGroup>

                <FormGroup>
                    <ControlLabel>Notes</ControlLabel>
                    <FormControl name="Notes" value={state.Notes} onChange={(e) => { onChangeAddNewContainer(e, 'Notes') }} onInput={(e) => e.target.value = textStringInputMask(e)} />
                </FormGroup>

                <FormGroup>
                    <ButtonToolbar>
                        <Button onClick={confirm} appearance="primary">Submit</Button>
                        <Button onClick={close} appearance="default">Cancel</Button>
                    </ButtonToolbar>
                </FormGroup>
            </Form>

        </div> </Drawer.Body>
        <Drawer.Footer>
            <br />
        </Drawer.Footer>

    </Drawer>

);



AddNewContainerDrawer.defaultProps = {
    show: false
};

export default AddNewContainerDrawer;


